// Assessment Constants

export const DIFFICULTY_LEVELS = {
  BEGINNER: 'Beginner',
  INTERMEDIATE: 'Intermediate',
  ADVANCED: 'Advanced',
} as const;

export const DIFFICULTY_LEVELS_ARRAY = Object.values(DIFFICULTY_LEVELS);

export type DifficultyLevel = typeof DIFFICULTY_LEVELS[keyof typeof DIFFICULTY_LEVELS];

export const ANSWER_OPTIONS = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
} as const;

export const ANSWER_OPTIONS_ARRAY = Object.values(ANSWER_OPTIONS);

export type AnswerOption = typeof ANSWER_OPTIONS[keyof typeof ANSWER_OPTIONS];

// Default categories (can be managed via API)
export const DEFAULT_CATEGORIES = [
  'Technical Skills',
  'Soft Skills',
  'Industry Knowledge',
  'Compliance',
  'General Knowledge',
  'Problem Solving',
  'Communication',
  'Leadership',
] as const;